// extracted by mini-css-extract-plugin
export default {"link":"ClickToCopy-module--link--053b0","value":"ClickToCopy-module--value--f439c","copied":"ClickToCopy-module--copied--b0cae"};